module.exports = __webpack_public_path__ + "img/bg_mobile_6db556d.webp";